import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import { FieldSet, Card, KeyValue } from '../elements';
import { convertCurrencyValue, formatCurrency } from '../../lib/utils';

class PaymentPlans extends React.Component {
  groupByPaymentPlans = (currentPaymentPlans) => {
    const { financePlan } = this.props;
    const groupedPayments = groupBy(currentPaymentPlans, (c) => c.date);

    return Object.keys(groupedPayments).map((date, index) => ({
      name: groupedPayments[date][0].name,
      date:
        index === 0 ||
        (index > 0 && financePlan.show_due_date_in_all_installments)
          ? date
          : '-',
      value: groupedPayments[date].reduce(
        (acc, payment) => acc + convertCurrencyValue(payment.value),
        0
      ),
    }));
  };

  render() {
    const { financePlan, paymentPlans } = this.props;
    if (financePlan) {
      const currentPaymentPlans = paymentPlans.filter(
        (p) => +p.finance_plan === +financePlan.id
      );
      return (
        <>
          <FieldSet title="Plano de Pagamento" />
          <div className="list-base">
            {this.groupByPaymentPlans(currentPaymentPlans).map(
              (currentPaymentPlan) => (
                <Card>
                  <div className="enrollment-flex text-center">
                    <KeyValue
                      title={currentPaymentPlan.name}
                      label="Plano de Pagamento"
                    />
                    <KeyValue title={currentPaymentPlan.date} label="Data" />
                    <KeyValue
                      title={formatCurrency(currentPaymentPlan.value)}
                      label="Valor"
                    />
                  </div>
                </Card>
              )
            )}
          </div>
        </>
      );
    }
    return null;
  }
}

PaymentPlans.propTypes = {
  financePlan: PropTypes.shape({
    id: PropTypes.number,
  }),
  paymentPlans: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      date: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};

PaymentPlans.defaultProps = {
  financePlan: undefined,
  paymentPlans: [],
};

export default PaymentPlans;
